import cn from 'classnames'
import styles from './StatusBanner.module.scss'

interface StatusBannerProps {
  status: string
}

export const StatusBanner = ({ status }: StatusBannerProps) => {
  return status ? (
    <span
      className={cn(
        styles['status-banner-wrapper'],
        'status-banner-wrapper',
        `status-box ${status.toLowerCase()?.replace(' ', '-')}`
      )}
    >
      {status}
    </span>
  ) : null
}
